import BigDecimal from "big.js";

BigDecimal.RM = 1; // This sets BigDecimal's rounding method to ROUND_HALF_UP

const calculateRetailPrice = (vendorOptions: VendorOptionState[], retailPrice: BigDecimal): number => {
  const retailPriceString = retailPrice.toString(); // Convert BigDecimal to a string
  const retailPriceNumber = parseFloat(retailPriceString); // Convert the string to a JavaScript number

  if (!isNaN(retailPriceNumber) && retailPriceNumber > 0) {
    const highestPriceVendorOption = getHighestVendorOptionPriceModified(vendorOptions);
    if (retailPriceNumber < highestPriceVendorOption) {
      return highestPriceVendorOption;
    } else {
      return retailPriceNumber;
    }
  } else {
    return getHighestVendorOptionPriceModified(vendorOptions);
  }
};

export default calculateRetailPrice;

const getHighestVendorOptionPriceModified = (vendorOptions: VendorOptionState[]): number => {
  const sortedVendorOptions = [...vendorOptions].sort((vo1, vo2) => {
    const vo1UnitPrice = getVendorOptionHighestPrice(vo1.priceBreaks);
    const vo2UnitPrice = getVendorOptionHighestPrice(vo2.priceBreaks);

    if (vo1UnitPrice === vo2UnitPrice) {
      return 0; // Use strict equality check for numbers
    } else {
      return vo1UnitPrice > vo2UnitPrice ? -1 : 1;
    }
  });

  const highestVendorOptionPrice = sortedVendorOptions[0]?.highestVendorOptionPrice;
  return highestVendorOptionPrice === 0
    ? getVendorOptionHighestPrice(sortedVendorOptions[0]?.priceBreaks)
    : highestVendorOptionPrice;
};

const getVendorOptionHighestPrice = (priceBreaks: VendorOptionPriceBreakState[]): number => {
  const sortedPriceBreaks = [...priceBreaks].sort((pb1, pb2) => {
    const pb1UnitPrice = parseFloat(pb1.unitPrice.toString()); // Convert BigDecimal to a JavaScript number
    const pb2UnitPrice = parseFloat(pb2.unitPrice.toString()); // Convert BigDecimal to a JavaScript number

    if (pb1UnitPrice === pb2UnitPrice) {
      return 0; // Use strict equality check for numbers
    } else {
      return pb1UnitPrice > pb2UnitPrice ? -1 : 1;
    }
  });

  return parseFloat(sortedPriceBreaks[0].unitPrice.toString()); // Convert BigDecimal to a JavaScript number
};
